import { useMountEffect } from './useMountEffect';
import { shellEventBus } from '../services/shellBridge';
import { drawerSlotStore } from '../services/drawerSlots/drawerSlotStore';

/** True when any shell-managed (non-module) drawer is open. */
function isAnyManagedDrawerOpen(): boolean {
  return drawerSlotStore.getSnapshot().some((slot) => slot.tier === 'managed' && slot.open);
}

/**
 * Bridges the (non-React) drawer slot store to the shell event bus: emits
 * `shellDrawerOpen` whenever a shell-managed drawer (e.g. OG Assist) transitions
 * from closed to open. Embedded modules subscribe via `shell.subscribe(...)` to
 * close their own right-side panels, keeping shell and module drawers mutually
 * exclusive.
 *
 * Mount-only external subscription — there is no reactive dependency, so this is
 * a genuine `useMountEffect` case. We only fire on the closed→open edge so a
 * module dismissing a shell drawer (open→closed) does not loop back.
 */
export function useDrawerSlotBroadcast(): void {
  useMountEffect(() => {
    let wasOpen = isAnyManagedDrawerOpen();
    return drawerSlotStore.subscribe(() => {
      const isOpen = isAnyManagedDrawerOpen();
      if (isOpen && !wasOpen) {
        shellEventBus.emit('shellDrawerOpen');
      }
      wasOpen = isOpen;
    });
  });
}
